import {useFeatureFlags} from '@github-ui/react-core/use-feature-flag'
import type {ReactionViewerGroups$key, ReactionViewerUser$key} from '@github-ui/reaction-viewer'
import {ReactionViewer} from '@github-ui/reaction-viewer'
import type {SafeHTMLString} from '@github-ui/safe-html'
import {Box} from '@primer/react'
import type {RefObject} from 'react'

import {AddTasklistButton} from './AddTasklistButton'
import {IssueBodyMarkdownViewer, IssueMarkdownContext} from './IssueBodyMarkdownViewer'

export type IssueBodyViewerProps = {
  id: string
  html: SafeHTMLString
  markdown: string
  viewerCanUpdate: boolean
  reactionGroups: ReactionViewerGroups$key
  viewer: ReactionViewerUser$key
  onLinkClick?: (event: MouseEvent) => void
  locked: boolean
  viewerRef: RefObject<HTMLDivElement>
}

export function IssueBodyViewer({
  id,
  html,
  markdown,
  viewerCanUpdate,
  reactionGroups,
  viewer,
  onLinkClick,
  locked,
  viewerRef,
}: IssueBodyViewerProps) {
  const {tasklist_block} = useFeatureFlags()

  return (
    <Box sx={{display: 'flex', flexDirection: 'column', gap: 4, px: 3, pt: 2, pb: 3}}>
      <IssueBodyMarkdownViewer
        context={IssueMarkdownContext.Issue}
        id={id}
        html={html}
        markdown={markdown}
        viewerCanUpdate={viewerCanUpdate}
        onLinkClick={onLinkClick}
      />
      <Box sx={{flexDirection: 'row', display: 'flex', alignItems: 'left'}}>
        {tasklist_block && viewerCanUpdate && <AddTasklistButton bodyRef={viewerRef} />}
        <ReactionViewer subjectId={id} reactionGroups={reactionGroups} viewer={viewer} locked={locked} />
      </Box>
    </Box>
  )
}

try{ IssueBodyViewer.displayName ||= 'IssueBodyViewer' } catch {}